var map = {
	"./1.jpg": 4261,
	"./2.jpg": 8010,
	"./3.jpg": 3847,
	"./4.jpg": 7852,
	"./5.jpg": 8905,
	"./6.jpg": 1790,
	"./7.jpg": 9835,
	"./8.jpg": 8224,
	"./9.jpg": 6797,
	"./mainImg.jpg": 9176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7703;